import { useSyncExternalStore } from "react";

// The browser's own online / offline state (navigator.onLine + the online / offline events).
// It flips when the device loses its network (Wi-Fi off, cable out); a network that is up
// but has no route to the internet still reads as online.

function subscribe(onChange) {
  window.addEventListener("online", onChange);
  window.addEventListener("offline", onChange);
  return () => {
    window.removeEventListener("online", onChange);
    window.removeEventListener("offline", onChange);
  };
}

const getSnapshot = () => navigator.onLine !== false;
const getServerSnapshot = () => true;

export default function useOnlineStatus() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
